
const host_state = true  //true为正式，false为测试

// 测试接口
let host = 'https://learning-api.52shanglu.com/';
if(host_state){
    // 正式接口
    host = 'https://resource-api.changqinos.com';
}

export default {
    host,
    host_state,
}